import IFaturaInstalacao from "../interfaces/IFaturaInstalacao";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class FaturaInstalacaoService {
    async getAll() {
        return await api.get(`${resources.faturaInstalacao}/GetAll`);
    }

    async get(id: string) {
        return await api.get(`${resources.faturaInstalacao}/${id}`);
    }

    async create(data: IFaturaInstalacao) {
        return await api.post(resources.faturaInstalacao, data);
    }

    async update(data: IFaturaInstalacao) {
        return await api.put(`${resources.faturaInstalacao}/Update`, data);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.faturaInstalacao}/Approve/${id}`);
    }

    async approveAll() {
        return await api.put<any>(`${resources.faturaInstalacao}/ApproveAll`);
    }

    async reopen(data: any) {
        return await api.put<any>(`${resources.faturaInstalacao}/Reopen/${ToQueryString(data)}`);
    }

    async reverterReaberturaIndevida(id: any, motivo: string, saldos?: { tipoSaldo: string; quantidadeKWAposReversao: number }[]) {
        return await api.put<any>(`${resources.faturaInstalacao}/ReverterReaberturaIndevida/${id}?motivo=${encodeURIComponent(motivo)}`, saldos ?? []);
    }

    async previewReverterReaberturaIndevida(id: any) {
        return await api.get<any>(`${resources.faturaInstalacao}/PreviewReverterReaberturaIndevida/${id}`);
    }

    async delete(id: any) {
        return await api.delete(`${resources.faturaInstalacao}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async createByFaturaPrevista(data: any) {
        return await api.post<IFaturaInstalacao>(
            `${resources.faturaInstalacao}/CreateByFaturaPrevista/${ToQueryString(data)}`
        );
    }

    async createByFaturaConcessionaria(data: any) {
        return await api.post<IFaturaInstalacao>(
            `${resources.faturaInstalacao}/CreateByFaturaConcessionaria/${ToQueryString(data)}`
        );
    }

    async recalculate(id: any, tipoRecalculo?: string) {
        const queryParam = tipoRecalculo ? `?tipoRecalculo=${tipoRecalculo}` : '';
        return await api.post(`${resources.faturaInstalacao}/Recalculate/${id}${queryParam}`);
    }

    async approveMany(data: any) {
        return await api.post<any>(`${resources.faturaInstalacao}/ApproveMany`, data);
    }


    async alterStatus(payload: {
        FaturasIds: string;
        novoStatus: string;
        motivo: string;
    }) {
        return await api.post<any>(`${resources.faturaInstalacao}/AlterStatusMany`, payload);
    }

}

export default new FaturaInstalacaoService();
